export default __webpack_public_path__ + "static/telegraph-best-buy-logo-f342ff2a48f96d360882565e3be1d7d4.png";